"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ExpandIcon = /*#__PURE__*/function (_React$Component) {
  function ExpandIcon() {
    _classCallCheck(this, ExpandIcon);
    return _callSuper(this, ExpandIcon, arguments);
  }
  _inherits(ExpandIcon, _React$Component);
  return _createClass(ExpandIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("svg", {
        className: "expand-icon icon",
        xmlns: "https://www.w3.org/2000/svg",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 125",
        enableBackground: "new 0 0 100 100"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polyline", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        points: "25,15 15,15 15.001,25  "
      }), /*#__PURE__*/_react["default"].createElement("line", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        x1: "45",
        y1: "45",
        x2: "15",
        y2: "15"
      }), /*#__PURE__*/_react["default"].createElement("line", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        x1: "55",
        y1: "45",
        x2: "85",
        y2: "15"
      }), /*#__PURE__*/_react["default"].createElement("polyline", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        points: "85,25 85,15 75,15.001  "
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polyline", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        points: "15.001,75 15,85 25,85  "
      }), /*#__PURE__*/_react["default"].createElement("line", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        x1: "15",
        y1: "85",
        x2: "45",
        y2: "55"
      }), /*#__PURE__*/_react["default"].createElement("line", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        x1: "85",
        y1: "85",
        x2: "55",
        y2: "55"
      }), /*#__PURE__*/_react["default"].createElement("polyline", {
        fill: "none",
        stroke: "#000000",
        strokeWidth: "5",
        strokeMiterlimit: "10",
        points: "75,84.999 85,84.999 85,75  "
      })));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(ExpandIcon);